import React, { useState } from "react";

import styles from "./EditKcard.module.css";

import ButtonSave from "./Buttons/ButtonSave";
import LoadingSpinner from "./LoadingSpinner";
import Card from "./Card";
import IconTrash from "./Icons/IconTrash";

const EditKcard = function (props) {
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [img, setImage] = useState(props.img);
  const [query, setQuery] = useState(props.query);
  const [result, setResult] = useState(props.result);
  const [info, setInfo] = useState(props.info);
  const [isLoading, setIsLoading] = useState(false);

  const handleResultChange = function (e) {
    setResult(e.target.value);
  };

  const handleQueryChange = function (e) {
    setQuery(e.target.value);
  };

  const handleInfoChange = function (e) {
    setInfo(e.target.value);
  };

  const onSubmitHandler = async function (e) {
    e.preventDefault();
    setIsSaving(true);

    await props.updateKcardHandler({ img, query, result, info });

    setIsSaving(false);
    setIsSaved(true);
    setTimeout(() => {
      setIsSaved(false);
    }, 2000);
  };

  return (
    <div className={styles.backdrop}>
      <Card className={styles.card}>
        <form
          id={props.id}
          className={styles.kcard}
          onSubmit={onSubmitHandler}
          autoComplete="off"
        >
          {isSaving && (
            <div className={styles["status-indicators"]}>
              <LoadingSpinner className={styles.saving} />
            </div>
          )}
          {!isSaving && isSaved && (
            <div className={styles["status-indicators"]}>
              <p className={styles["card-saved"]}>Card saved ✓</p>
            </div>
          )}
          <div className={styles["kcard-img"]}>
            {!isLoading && <img src={img} className={styles.img} alt="" />}
            {isLoading && <LoadingSpinner />}
          </div>

          <div className={styles.content}>
            <div className={styles["kcard-text"]}>
              <input
                id="result"
                className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--lg"]}`}
                type="text"
                placeholder={props.result}
                value={result}
                onChange={handleResultChange}
              />
              <input
                id="query"
                className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--md"]}`}
                type="text"
                placeholder={props.query}
                value={query}
                onChange={handleQueryChange}
              />
              <input
                id="info"
                className={`${styles["kcard-text__input"]} ${styles["kcard-text__input--sm"]}`}
                type="text"
                placeholder={props.info}
                value={info}
                onChange={handleInfoChange}
              />
            </div>
            <ButtonSave disabled={isSaving}></ButtonSave>
          </div>
        </form>
        <button
          className={styles.delete}
          onClick={props.deleteKcardHandler}
          type="button"
        >
          <IconTrash className={styles["delete-icon"]} />
        </button>
      </Card>
    </div>
  );
};

export default EditKcard;
